<template>
          <v-sheet>
            <v-chip  v-if="search" >
            {{ tocurr(balance) }}
          </v-chip>
          <v-data-table :headers="headers" :items="debits" :search="search"
           class="elevation-1" height="450px"
          :loading="loading" loading-text="Loading... Please wait"
          show-group-by
          @current-items="updateFilteredItems"
          >

          <template v-slot:item.actions="{ item }">
            <v-icon v-if="item.PaymTerm == 0">mdi-cash-multiple</v-icon>
            <span v-if="item.PaymTerm == 1">
            {{ item.Remarks.split("@").pop() }}
            <v-icon>mdi-bank-transfer-out</v-icon>
            </span>
            <span v-if="item.PaymTerm == 2">{{ item.Remarks.split("@").pop() }}
            <v-icon >mdi-credit-card-chip</v-icon>
            </span>
            
            <v-icon v-if="item.PaymTerm == 3">mdi-checkbook</v-icon>
          </template>

          <template
            v-slot:group.header="{ group, items, isOpen, toggle, remove }"
          >
            <th colspan="10">
              <v-icon @click="toggle"
                >{{ isOpen ? "mdi-minus" : "mdi-plus" }}
              </v-icon>
              {{ group }}: {{ tocurr(sumField(items, "TotalValue")) }}
              <v-icon @click="remove">mdi-close </v-icon>
            </th>
          </template>

          <template v-slot:item.NetValue="{ item }">
            {{ tocurr(item.NetValue) }}
          </template>
          <template v-slot:item.TotalValue="{ item }">
            {{ tocurr(item.TotalValue) }}
          </template>
          <template v-slot:item.VatValue="{ item }">
            {{ tocurr(item.VatValue) }}
          </template>
          </v-data-table>
          </v-sheet>
</template>

<script>
export default {
  computed: {
    //pist () { return this.tocurr(this.sumField(this.debits.filter(e => (e.PaymTerm == "Με πίστωση" && e.state == "Κανονικό") ), 'TotalValue')); },
    //metr () { return this.tocurr(this.sumField(this.debits.filter(e => (e.PaymTerm == "Μετρητοίς"&& e.state == "Κανονικό")), 'TotalValue')); },
    //total () { return this.tocurr(this.sumField(this.debits.filter(e => e.state == "Κανονικό"), 'TotalValue')); },

  },
  props: {
    debits: {required: true, type: Array},
    loading: {default: true},
    search: {default: ''},
    contact: {default: 'Customer.Name'}
  },
  data() {
    return {
      balance: 0.0,
      headers: [
        {
          text: "Α/A",
          align: "start",
          //sortable: false,
          value: "DocNumber",
          width: "5%",
          groupable: false,
        },
        { text: "Ημερομηνία", value: "Date", width: "10%" },
        { text: "Πελάτης", value: this.contact, width: "45%" },
        //{ text: "Οχημα", value: "PlateNumber", width: "10%", groupable: false },
       // {
       //   text: "Καθαρή αξία",
       //   value: "NetValue",
       //   align: "end",
       //   groupable: false,
       // },
       // { text: "ΦΠΑ", value: "VatValue", align: "end", groupable: false },
        { text: "Συνολο", value: "TotalValue", align: "end", groupable: false },
        {
          text: "Τρόπος",
          value: "actions",
          groupable: false,
          sortable: false,
        },
       // { text: "", value: "data-table-expand", groupable: false },

      ],
    }
  },
  methods: {

    updateFilteredItems (items) {
      this.balance = this.sumField(items, "TotalValue");
    },
    isodate(date) {
      return date.toISOString().substr(0, 10);
    },
    sumField(items, key) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b[key] || 0), 0);
    },
    tocurr(value) {
      return new Intl.NumberFormat("el-GR", {
        style: "currency",
        currency: "EUR",
      }).format(value);
    },
  }
}
</script>
